import { onBeforeUnmount, onMounted, ref } from 'vue';

// The kit's colours for a chart.js chart. chart.js paints on a canvas and does not understand `var(--…)`, so each role
// is resolved to a colour through a probe element inside `body` (where the dashboard puts `.dark`), and read again when
// the theme class changes on `html` or `body`, so a chart that is open while the theme flips repaints in the new one.
// Series 1 is the bar, series 3 the conversation-count line over the average bars (7-1: chart.js dressed in the kit).
const ROLES = {
  bar: '--polaris-chart-1',
  line: '--polaris-chart-3',
  text: '--polaris-muted-foreground',
  grid: '--polaris-border',
  tooltip: '--polaris-popover',
  tooltipText: '--polaris-popover-foreground',
};

const read = () => {
  const probe = document.createElement('span');
  probe.style.display = 'none';
  document.body.appendChild(probe);
  const colors = Object.fromEntries(
    Object.entries(ROLES).map(([key, variable]) => {
      probe.style.color = `var(${variable})`;
      return [key, getComputedStyle(probe).color];
    })
  );
  probe.remove();
  return colors;
};

export function useReportChartTheme() {
  const colors = ref(read());
  let observer;
  onMounted(() => {
    observer = new MutationObserver(() => {
      colors.value = read();
    });
    [document.documentElement, document.body].forEach(element =>
      observer.observe(element, {
        attributes: true,
        attributeFilter: ['class'],
      })
    );
  });
  onBeforeUnmount(() => observer?.disconnect());
  return { colors };
}
